import { render, staticRenderFns } from "./tasks-page.vue?vue&type=template&id=6b2d9022&scoped=true&"
import script from "./tasks-page.vue?vue&type=script&lang=js&"
export * from "./tasks-page.vue?vue&type=script&lang=js&"
import style0 from "./tasks-page.vue?vue&type=style&index=0&id=6b2d9022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2d9022",
  null
  
)

export default component.exports